// extracted by mini-css-extract-plugin
export default {"wrap":"archive_wrap__fjIgB","row":"archive_row__cO2Ad"};